import React, { useState, useEffect } from "react";
import { Row, Col, Input, Button, Typography, message } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import bgImg from "../../assets/bg_img.jpg";
import arrowleft from "../../assets/back-arrow.svg";
import { useNavigate } from "react-router-dom";
import { useAllProduct } from "../../components/api-context/commonApiContext";
import Config from "../../config/Config";

const { Title, Text } = Typography;

const SignUp = () => {
  const {
    merchantInfo,
    setUserKycStatus,
    setMoneyLoadStatus,
    phoneNo,
    setPhoneNo,
  } = useAllProduct();

  const [showOtp, setShowOtp] = useState(false);
  const [otp, setOtp] = useState(["", "", "", ""]);
  const [timer, setTimer] = useState(150);
  const [errorMsg, setErrorMsg] = useState(""); // 🔴 Inline error message
  const navigate = useNavigate();

  useEffect(() => {
    if (!showOtp || timer <= 0) return;
    const interval = setInterval(() => setTimer((t) => t - 1), 1000);
    return () => clearInterval(interval);
  }, [showOtp, timer]);

  // useEffect(() => {
  //   if (!merchantInfo || !merchantInfo.merchant_id) return;

  //   const fetchUserStatus = async () => {
  //     try {
  //       const response = await fetch(
  //         "http://192.168.0.95:5051/get-user-status",
  //         {
  //           method: "POST",
  //           headers: { "Content-Type": "application/json" },
  //           body: JSON.stringify({ merchant_id: merchantInfo.merchant_id }),
  //         }
  //       );

  //       const result = await response.json();
  //       if (result.success) {
  //         console.log("✅ User Status:", result.data);
  //         setUserKycStatus(result.data.kyc_status);
  //         setMoneyLoadStatus(result.data.status);
  //         if (result.data.kyc_status === "completed") {
  //           navigate("/cart");
  //         }
  //       } else {
  //         console.warn("⚠️ Failed to fetch user:", result.message);
  //       }
  //     } catch (err) {
  //       console.error("❌ Error fetching user status:", err);
  //     }
  //   };

  //   fetchUserStatus();
  // }, [merchantInfo, navigate]);

  const handleGetOtp = () => {
    setErrorMsg(""); // clear previous error
    const mobileRegex = /^[6-9]\d{9}$/;
    if (!mobileRegex.test(phoneNo)) {
      setErrorMsg("Please enter a valid 10-digit mobile number.");
      return;
    }
    message.success("OTP sent successfully!");
    setShowOtp(true);
    setTimer(150);
  };

  const handleOtpChange = (value, index) => {
    setErrorMsg(""); // clear previous error
    if (/^\d?$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);
      if (value && index < otp.length - 1) {
        document.getElementById(`otp-${index + 1}`).focus();
      }
    }
  };

  const handleProceed = async () => {
    setErrorMsg("");
    if (otp.join("").length < 4) {
      setErrorMsg("Please enter complete OTP.");
      return;
    }

    message.success("OTP Verified Successfully!");
    console.log("Verified OTP:", otp.join(""));

    try {
      const response = await fetch(`${Config.node_api_endpoint}/user-detail`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-API-Key": process.env.REACT_APP_API_KEY,
        },
        body: JSON.stringify({
          phone_number: phoneNo,
          merchant_id: merchantInfo.merchant_id,
          payment_id: merchantInfo.payment_id,
        }),
      });

      const result = await response.json();
      if (result.success) {
        console.log("User:", result.data);
        // setUserId(result.data.user_id);
        if (
          result.data.kyc_status === "completed" &&
          result.data.status === "pending"
        ) {
          navigate("/payment");
        } else if (
          result.data.kyc_status === "completed" &&
          result.data.status === "completed"
        ) {
          navigate("/cart");
        } else {
          navigate("/kyc");
        }
      } else {
        setErrorMsg(
          result.message || "Failed to create user. Please try again."
        );
      }
    } catch (err) {
      console.error(err);
      setErrorMsg("Server unreachable. Please check your connection.");
    }
  };

  const handleResend = () => {
    message.info(`OTP resent to ${phoneNo}`);
    setTimer(150);
    setOtp(["", "", "", ""]);
    setErrorMsg("");
  };

  const handleBack = () => {
    setShowOtp(false);
    setErrorMsg("");
  };

  const minutes = String(Math.floor(timer / 60)).padStart(2, "0");
  const seconds = String(timer % 60).padStart(2, "0");
  // console.log("showOtp", merchantInfo);

  return (
    <div
      style={{
        backgroundImage: `url(${bgImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundAttachment: "fixed",
        height: "80vh",
        width: "100vw",
        position: "relative",
        color: "#fff",
        padding: "50px 20px 100px",
      }}
    >
      <div style={{ position: "absolute", inset: 0, zIndex: 0 }} />

      <Row
        justify="center"
        style={{
          position: "relative",
          zIndex: 2, // keep content above overlay
          width: "100%",
          maxWidth: 420,
          margin: "0 auto",
        }}
      >
        <Col xs={24}>
          {/* Header */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: 20,
              height: 40,
            }}
          >
            <img
              src={arrowleft}
              style={{ cursor: "pointer" }}
              alt="Back"
              onClick={() => {
                if (showOtp) handleBack(); // only works on OTP screen
              }}
            />

            <Title
              level={4}
              style={{
                color: "#333333",
                margin: 0,
                position: "absolute",
                left: "50%",
                transform: "translateX(-50%)",
                // width: "100%",
                textAlign: "center",
              }}
            >
              Sign Up
            </Title>
          </div>

          <Text style={{ color: "#fff", fontWeight: 700, fontSize: "18px" }}>
            <span style={{ color: "#333333" }}>Welcome to </span>{" "}
            <span style={{ color: "#2348AB" }}>Khazana Card</span>
          </Text>

          {/* --- Step 1: Mobile Input --- */}
          {!showOtp && (
            <>
              <Title
                level={5}
                style={{ color: "#333333", marginTop: 20, marginBottom: 10 }}
              >
                Verify your mobile number
              </Title>

              <Text
                style={{
                  color: "#bbb",
                  display: "block",
                  marginBottom: 20,
                  fontSize: 14,
                  lineHeight: 1.4,
                }}
              >
                We will send an{" "}
                <b style={{ color: "#333333" }}>One Time Password (OTP)</b> to
                your registered mobile number.
              </Text>

              <Text style={{ color: "#333333", fontSize: 14, fontWeight: 600 }}>
                Mobile Number linked with Aadhaar
              </Text>

              <Input
                inputMode="numeric"
                maxLength={10}
                placeholder="Enter mobile number"
                size="large"
                value={phoneNo}
                onChange={(e) => setPhoneNo(e.target.value)}
                style={{
                  borderRadius: 8,
                  marginTop: 8,
                  marginBottom: 10,
                  border: "1px solid rgba(77,163,255,0.8)",
                }}
              />

              {/* 🔴 Inline error message */}
              {errorMsg && (
                <div style={{ color: "red", fontSize: 13, marginBottom: 15 }}>
                  {errorMsg}
                </div>
              )}

              <Button
                type="primary"
                block
                size="large"
                onClick={handleGetOtp}
                style={{
                  backgroundColor: "#2348AB",
                  borderRadius: 10,
                  border: "none",
                  boxShadow: "0 0 15px rgba(35,72,171,0.6)",
                  fontWeight: 600,
                }}
              >
                Get OTP
              </Button>
            </>
          )}

          {/* --- Step 2: OTP Input --- */}
          {showOtp && (
            <>
              <Title
                level={5}
                style={{ color: "#333333", marginTop: 20, marginBottom: 10 }}
              >
                OTP Verification
              </Title>

              <Text
                style={{ color: "#bbb", display: "block", marginBottom: 30 }}
              >
                Enter the code from the SMS we sent to
                <b style={{ color: "#333333", fontWeight: "600" }}>
                  &nbsp;{phoneNo}
                </b>
                .
              </Text>

              {/* Timer */}
              <div
                style={{
                  textAlign: "center",
                  fontWeight: 600,
                  color: "#2348AB",
                  marginBottom: 12,
                }}
              >
                {minutes}:{seconds}
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  gap: 12,
                  marginBottom: 8,
                }}
              >
                {otp.map((digit, index) => (
                  <Input
                    key={index}
                    id={`otp-${index}`}
                    type="tel"
                    maxLength={1}
                    value={digit}
                    onChange={(e) => handleOtpChange(e.target.value, index)}
                    inputMode="numeric"
                    style={{
                      width: 55,
                      height: 55,
                      textAlign: "center",
                      fontSize: 24,
                      fontWeight: 600,
                      borderRadius: 8,
                      backgroundColor: "rgba(255,255,255,0.9)",
                      border: "1px solid rgba(77,163,255,0.9)",
                      boxShadow: "0 0 12px rgba(77,163,255,0.5)",
                      color: "#000",
                    }}
                  />
                ))}
              </div>

              {/* 🔴 Inline error message under OTP inputs */}
              {errorMsg && (
                <div style={{ color: "red", fontSize: 13, marginBottom: 15 }}>
                  {errorMsg}
                </div>
              )}

              <div
                style={{
                  textAlign: "center",
                  color: "#bbb",
                  fontSize: 14,
                  marginBottom: 20,
                }}
              >
                Didn’t receive the OTP?{" "}
                <span
                  style={{
                    color: "#2348AB",
                    fontWeight: 500,
                    cursor: "pointer",
                  }}
                  onClick={handleResend}
                >
                  RESEND
                </span>
              </div>

              <Button
                type="primary"
                block
                size="large"
                onClick={handleProceed}
                style={{
                  backgroundColor: "#2348AB",
                  borderRadius: 10,
                  border: "none",
                  boxShadow: "0 0 18px rgba(35,72,171,0.6)",
                  fontWeight: 600,
                }}
              >
                Proceed
              </Button>
            </>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default SignUp;
